export const setCurrentUser = (payload) => ({
    type: "SET_CURRENT_USER",
    payload: payload
})
